<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<!-- MAIN (Center website) -->
<div class="page-container">
  <div class="header">
    <div class="logo header-content"></div>
    <ul class="user-actions header-content">
      <li><a routerLink="/login">Sign in </a></li>
    </ul>
  </div>
  <div class="nav">
    <ul class="nav-options">
      <li>Our Product</li>
      <li>Plans</li>
      <li>Help</li>
      <li>Contact</li>
    </ul>
  </div>
  <h1>Fill up your Organisation details</h1>

  <form #orgForm="ngForm">
    <input hidden name="usereid" [(ngModel)]="organisation.usereid" type="text" #usereid="ngModel" class="form-control"
      readonly required />

    <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <app-drag-drop
        class="file-container"
        (fileSelected)="fileSelected($event)"
        [supportedFormats]="'.png,.jpeg'"
        [multiple]="false"
      ></app-drag-drop>
    </div> -->

    <input type="text" pattern="[a-zA-Z0-9\s]+" required [(ngModel)]="organisation.oname" name="oname" #oname="ngModel"
      class="form-control" placeholder="Organization Name" ng required />

    <div class="alert" *ngIf="!oname.valid">
      <img src="assets/images/icon-alert.png" /> This Field is required, Must be
      Alphabets
    </div>

    <input type="text" required [(ngModel)]="organisation.org_eid" name="org_eid" #org_eid="ngModel"
      class="form-control" placeholder="Organisation Email-id" [pattern]="emailpat" />
    <div class="alert alert-danger" *ngIf="!org_eid.valid">
      <img src="assets/images/icon-alert.png" />
      <span *ngIf="org_eid?.errors?.required"> This field is required</span>
      <span *ngIf="org_eid?.errors?.pattern"> This field is invalid</span>
    </div>

    <input type="text" required [(ngModel)]="organisation.address1" name="address1" #address1="ngModel"
      class="form-control" placeholder="Address Line 1" />
    <div class="alert alert-danger" *ngIf="!address1.valid">
      <img src="assets/images/icon-alert.png" /> This field is required
    </div>

    <input type="text" [(ngModel)]="organisation.address2" name="address2" #address2="ngModel" class="form-control"
      placeholder="Address Line 2(Optional) " />

    <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="organisation.city" name="city" #city="ngModel"
      class="form-control" placeholder="City" />

    <div class="alert alert-danger" *ngIf="!city.valid">
      <img src="assets/images/icon-alert.png" />
      This field is required & allows Alphabets only
    </div>

    <input type="text" pattern="[a-zA-Z\s]+" required [(ngModel)]="organisation.state" name="state" #state="ngModel"
      class="form-control" placeholder="State" />

    <div class="alert alert-danger" *ngIf="!state.valid">
      <img src="assets/images/icon-alert.png" /> This field is required & allows
      Alphabets only
    </div>

    <input type="number" required [(ngModel)]="organisation.zip" name="zip" #zip="ngModel" class="form-control"
      placeholder="Zip Code" min="0" [pattern]="zipRegex" />
    <div class="alert" *ngIf="!zip.valid">
      <img src="assets/images/icon-alert.png" />
      <span *ngIf="zip?.errors?.required">This field is required</span>
      <span *ngIf="zip?.errors?.pattern">This field is invalid</span>
    </div>

    <button class="form-control" type="button" (click)="addOrg()" class="btn primary-btn" [disabled]="!orgForm.valid"
      name="submit">
      Submit
    </button>
  </form>
</div>